var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 15,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8365 48L17.5077 19.104H25.636L18.9648 48H10.8365Z",
    fill: "url(#paint0_linear_8225_3380)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2094 19.1041L17.0378 11.1841H25.1662L23.3377 19.1041H15.2094Z",
    fill: "url(#paint1_linear_8225_3380)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0767 19.104L31.8674 37.3365C31.3754 39.4675 29.2491 40.7962 27.1181 40.3042C24.9871 39.8122 23.6584 37.6859 24.1504 35.5549L27.9484 19.104H36.0767Z",
    fill: "url(#paint2_linear_8225_3380)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7558 19.1043H25.6274L26.2659 16.3386C26.7579 14.2076 28.8843 12.8789 31.0153 13.3709C33.1463 13.8629 34.4749 15.9892 33.983 18.1202L33.7558 19.1043Z",
    fill: "url(#paint3_linear_8225_3380)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4599 11.1843H20.3315L21.2582 7.17066C21.7502 5.03966 23.8765 3.71098 26.0075 4.20296C28.1385 4.69494 29.4672 6.82128 28.9752 8.95227L28.4599 11.1843Z",
    fill: "url(#paint4_linear_8225_3380)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8225_3380",
    x1: 23.6881,
    y1: 29.208,
    x2: 23.6881,
    y2: 19.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E4E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8225_3380",
    x1: 23.8557,
    y1: 15.6481,
    x2: 23.8557,
    y2: 11.1841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E4E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8225_3380",
    x1: 34.4935,
    y1: 29.76,
    x2: 34.4935,
    y2: 19.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E4E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8225_3380",
    x1: 32.9721,
    y1: 15.3091,
    x2: 32.9721,
    y2: 11.1363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E4E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8225_3380",
    x1: 27.9264,
    y1: 9.60033,
    x2: 27.9264,
    y2: 4.10059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E4E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6d4424e06026c08b1b761ea7b1127866.svg";
export { ForwardRef as ReactComponent };